import { useEffect, useState } from 'react';

import { IProductProps } from 'store/modules/product';

import * as S from './styles';

interface DescriptionProps {
  product: IProductProps;
}

export function Description({ product }: DescriptionProps) {
  const {
    descricaoGeral: descricao,
    descricaoAplicacao: modoDeUso,
    descricaoTecnica,
    descricaoAdicional: outrasInformacoes,
    farmacia: { bulaUrl: bula },
  } = product;

  const [additionalInfo, setShowAdditionalInfo] = useState(true);

  const tabPagination = [
    !!descricao && { id: 0, title: 'Descrição', icon: 'descricao' },
    !!modoDeUso && { id: 1, title: 'Modo de Uso', icon: 'mododeuso' },
    !!descricaoTecnica && {
      id: 2,
      title: 'Informação Técnica',
      icon: 'informacaotecnica',
    },
    (!!outrasInformacoes || additionalInfo) && {
      id: 3,
      title: 'Outras Informações',
      icon: 'outrasinformacoes',
    },
    !!bula && {
      id: 4,
      title: 'Bula',
      icon: 'bula',
    },
  ].filter(Boolean);

  const [howIsActive, setHowIsActive] = useState(null);

  useEffect(() => {
    if (
      !!product.descricaoAdicional ||
      !!product.codigo ||
      !!product.farmacia.registroMS ||
      product.farmacia.principioAtivo.length > 0 ||
      product.farmacia.classeTerapeutica.length > 0
    ) {
      setShowAdditionalInfo(true);
    } else {
      setShowAdditionalInfo(false);
    }
  }, [product]);

  return (
    <S.Container className="product-descriptions-info">
      <div className="tab-pagination-title">
        {tabPagination.map(tabItem => (
          <>
            {tabItem.id !== 4 ? (
              <div
                className={`tab-pagination-title-item${
                  howIsActive === tabItem.id ? ' active' : ''
                }`}
                key={tabItem.id}
                onClick={() => {
                  if (howIsActive === tabItem.id) setHowIsActive(null);
                  else setHowIsActive(tabItem.id);
                }}
              >
                {/* <img src={`/images/pdp-icons/${tabItem.icon}.svg`} alt="" /> */}
                <strong className={howIsActive === tabItem.id ? 'active' : ''}>
                  {tabItem.title}
                </strong>
              </div>
            ) : (
              <a
                href={bula}
                className={`tab-pagination-title-item${
                  howIsActive === tabItem.id ? ' active' : ''
                }`}
                key={tabItem.id}
                onClick={() => setHowIsActive(tabItem.id)}
                target="_blank"
              >
                {/* <img src={`/images/pdp-icons/${tabItem.icon}.svg`} alt="" /> */}
                <strong className={howIsActive === tabItem.id ? 'active' : ''}>
                  {tabItem.title}
                </strong>
              </a>
            )}
          </>
        ))}
      </div>

      {howIsActive === 0 ? (
        <div className="description-block">
          {/* <span className="title">DESCRIÇÃO</span> */}

          <div
            dangerouslySetInnerHTML={{
              __html: descricao,
            }}
          />
        </div>
      ) : howIsActive === 1 ? (
        <div className="description-block">
          {/* <span className="title">MODO DE USO</span> */}

          <div
            dangerouslySetInnerHTML={{
              __html: modoDeUso,
            }}
          />
        </div>
      ) : howIsActive === 2 ? (
        <div className="description-block">
          {/* <span className="title">INFORMAÇÃO TÉCNICA</span> */}

          <div
            dangerouslySetInnerHTML={{
              __html: descricaoTecnica,
            }}
          />
        </div>
      ) : (
        howIsActive === 3 &&
        (!!outrasInformacoes || additionalInfo) && (
          <div className="description-block">
            {/* <span className="title">OUTRAS INFORMAÇÕES</span> */}

            <div
              dangerouslySetInnerHTML={{
                __html: outrasInformacoes,
              }}
            />

            {additionalInfo && (
              <div className="additional-info">
                {product.codigo && (
                  <span>
                    <b>Código do produto: </b>
                    {product.codigo}
                  </span>
                )}

                {product.ean && (
                  <span>
                    <b>EAN: </b>
                    {product.ean}
                  </span>
                )}

                {product.farmacia.registroMS && (
                  <span>
                    <b>Registro MS: </b>
                    {product.farmacia.registroMS}
                  </span>
                )}

                {product.farmacia.principioAtivo.length > 0 && (
                  <div>
                    <b>Princípio Ativo: </b>
                    {product.farmacia.principioAtivo.map((item, index) => (
                      <span key={index}>
                        {index !== 0 && ', '}
                        {item.nome}
                      </span>
                    ))}
                  </div>
                )}

                {product.farmacia.classeTerapeutica.length > 0 && (
                  <div>
                    <b>Classe Terapêutica: </b>
                    {product.farmacia.classeTerapeutica.map((item, index) => (
                      <span key={index}>
                        {index !== 0 && ', '}
                        {item}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        )
      )}
    </S.Container>
  );
}
